import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-025bc70e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "platform",
  class: "platform"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleWrapper" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "platformTitle" }, "Our Platform Services")
], -1))
const _hoisted_3 = { class: "landing-page-container platforms-container" }
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "card"
        }, [
          _createElementVNode("img", {
            src: require(`../../assets/platform-image-${index + 1}.png`),
            alt: service.alt
          }, null, 8, _hoisted_4),
          _createElementVNode("h3", null, _toDisplayString(service.title), 1),
          _createElementVNode("p", null, _toDisplayString(service.description), 1),
          _createVNode(_component_Button, {
            class: "cardButton",
            disabled: service.disabled,
            onClick: ($event: any) => (_ctx.handleRedirect(service.type, service.path))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(service.buttonText), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]))
      }), 128))
    ])
  ]))
}